// services/matrixService.js
import { API_ENDPOINTS, apiClient } from './api';

const matrixService = {
  // Получение всей матрицы
  getMatrix: async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.MATRIX_POSITIONS);
      
      let positionsData = [];
      let brigadesData = [];
      
      // Прямой ответ
      if (response && response.positions && Array.isArray(response.positions)) {
        positionsData = response.positions;
      }
      
      if (response && response.brigades && Array.isArray(response.brigades)) {
        brigadesData = response.brigades;
      }
      
      // Вложенный ответ
      if (response && response.data) {
        if (response.data.positions && Array.isArray(response.data.positions)) {
          positionsData = response.data.positions;
        }
        if (response.data.brigades && Array.isArray(response.data.brigades)) {
          brigadesData = response.data.brigades;
        }
      }
      
      return {
        positions: positionsData,
        brigades: brigadesData
      };
    } catch (error) {
      console.error('Error fetching matrix:', error);
      return {
        positions: [],
        brigades: []
      };
    }
  },

  // Обновление назначения курса для должности
  updatePositionAssignment: async (positionId, courseId, assigned, isRequired = true) => {
    try {
      const endpoint = API_ENDPOINTS.MATRIX_POSITION_COURSE(positionId, courseId);
      console.log('PUT endpoint:', endpoint);
      
      const body = assigned 
        ? { assigned: true, is_required: isRequired }
        : { assigned: false };
      
      console.log('PUT body:', body);
      
      const response = await apiClient.put(endpoint, body);
      return response;
    } catch (error) {
      console.error(`Error updating position assignment: position=${positionId}, course=${courseId}`, error);
      throw error;
    }
  },

  // Обновление назначения курса для бригады
  updateBrigadeAssignment: async (brigadeId, courseId, assigned) => {
    try {
      const endpoint = API_ENDPOINTS.MATRIX_BRIGADE_COURSE(brigadeId, courseId);
      console.log('PUT endpoint:', endpoint);
      
      const body = { assigned: assigned };
      console.log('PUT body:', body);
      
      const response = await apiClient.put(endpoint, body);
      return response;
    } catch (error) {
      console.error(`Error updating brigade assignment: brigade=${brigadeId}, course=${courseId}`, error);
      throw error;
    }
  }
};

export { matrixService };